<header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <div class="navbar-header center">
            <img src="assets/images/Logo-Only.png" class="navbar-brand light-logo" alt="homepage" />
        </div>
        <div class="navbar-collapse">
            <div class="navbar-nav me-auto">
                <!-- Mobile menu toggler -->
                <a class="nav-link nav-toggler hidden-md-up menulist" href="javascript:void(0)"
                    (click)="toggleMobileMenu()">
                    <i class="bi bi-list"></i>
                </a>
            </div>
            <ul class="navbar-nav my-lg-0 header-nav" [class.mobile-nav-visible]="isMobileMenuOpen">
                <li class="nav-item dropdown" *ngIf="isMobile">
                    <ul class="dropdown-user">
                        <li>
                            <a [routerLink]="parentHomeLink" routerLinkActive="active" class="profile-li-mobile font-12"
                                (click)="closeMobileMenu()">
                                <i class="bi bi-house-door-fill"></i> Home
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="parentMyKidsLink" routerLinkActive="active"
                                class="profile-li-mobile font-12" (click)="closeMobileMenu()">
                                <i class="bi bi-people-fill"></i> My Kids
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="parentRegistrationLink" routerLinkActive="active"
                                class="profile-li-mobile font-12" (click)="closeMobileMenu()">
                                <i class=" bi bi-file-earmark-person-fill"></i> Registration
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="parentChatLink" class="profile-li-mobile font-12"
                                (click)="closeMobileMenu()">
                                <i class="bi bi-chat-dots-fill"></i> Messaging
                            </a>
                        </li>
                        <!-- <li>
                            <a [routerLink]="'/parent/notification'" class="profile-li-mobile font-12"
                                (click)="closeMobileMenu()">
                                <i class="bi bi-bell-fill"></i> Notifications
                            </a>
                        </li> -->
                    </ul>
                </li>
                <li *ngIf="!isMobile">
                    <a [routerLink]="parentHomeLink" routerLinkActive="active" class="nav-item">
                        <i class="icon bi bi-house-door-fill"></i>
                        <span>Home</span>
                    </a>
                </li>
                <li *ngIf="!isMobile">
                    <a [routerLink]="parentMyKidsLink" routerLinkActive="active" class="nav-item">
                        <i class="icon bi bi-people-fill"></i>
                        <span>My Kids</span>
                    </a>
                </li>
                <li *ngIf="!isMobile">
                    <a [routerLink]="parentRegistrationLink" routerLinkActive="active" class="nav-item">
                        <i class="icon bi bi-file-earmark-person-fill"></i>
                        <span>Registration</span>
                    </a>
                </li>
                <li *ngIf="!isMobile">
                    <a [routerLink]="parentChatLink" class="nav-item" routerLinkActive="active">
                        <i class="icon bi bi-chat-dots-fill"></i>
                        <span>Messaging</span>
                    </a>
                </li>
                <!-- <li *ngIf="!isMobile">
                    <a [routerLink]="'/parent/notification'" class="nav-item" routerLinkActive="active">
                        <i class="icon bi bi-bell-fill"></i>
                        <span>Notifications</span>
                    </a>
                </li> -->
            </ul>
            <ul class="navbar-nav my-lg-0">
                <li class="nav-item dropdown right-20" style="margin-left: 15px; margin-right: 30px;">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark profile-pic" href="#" id="navbarDropdown"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="bg-profile" [ngClass]="'bg-outline-green'">
                            <img src={{this.profileImageBase64}} alt="user" class="img-profile" />
                        </div>
                        <!-- <span class="profile-name">Me &nbsp;</span> -->
                        <span class="hidden-md-down profile-name">{{userDetail?.firstName + ' ' +
                            userDetail?.lastName}}
                            &nbsp;</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right drp-notification animated bounceInDown">
                        <ul class="dropdown-user">
                            <li>
                                <a [routerLink]="'/parent/myprofile'" class="profile-li font-12"><i
                                        class="bi bi-person"></i> My Profile</a>
                            </li>
                            <li *ngIf="hasAdminAndParentRole" class="role-switch-container">
                                <div class="role-switch">
                                    <span class="role-label"><i class="bi bi-people"></i> Current Role:
                                        <strong>{{ currentRole }}</strong></span>
                                    <button class="role-toggle-btn" (click)="toggleRole()">Switch to {{ switchToRole }}</button>
                                </div>
                            </li>
                            <li class="role-switch-container" *ngIf="schoolList.length > 1">
                                <div class="role-switch">
                                    <span class="role-label"><i class="bi bi-arrow-left-right"></i> Switch School:</span>
                                    <select [(ngModel)]="selectedSchool" class="role-dropdown">
                                        <option *ngFor="let sch of schoolList" [value]="sch">{{ sch }}</option>
                                    </select>
                                    <button class="role-toggle-btn" (click)="applySelectedSchool()">Apply</button>
                                </div>
                            </li>
                            <li>
                                <a href="#" class="profile-li font-12"><i class="bi bi-key" (click)="signOut()"></i>
                                    Sign Out</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</header>
<app-spinner [state]="loading"></app-spinner>
<app-toastr [properties]="alertProperties" *ngIf="showAlert"></app-toastr>
